import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=d32b6712&scoped=true"
import script from "./agree.vue?vue&type=script&lang=ts"
export * from "./agree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32b6712",
  null
  
)

export default component.exports